module.exports = __webpack_public_path__ + "img/cp9.96a0768c.png";